/* Footer Accordeons */

function initAccordion() {
  if (window.innerWidth <= 1200) {
    var items = document.querySelectorAll('.mobile-accordion__item');
    items.forEach(function (item) {
      var btn = item.querySelector('.mobile-accordion__toggle');
      if (!btn.getAttribute('data-initialized')) {
        btn.setAttribute('data-initialized', 'true');
        btn.addEventListener('click', function () {
          var expanded = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', !expanded);
          item.classList.toggle('active');
        });
      }
    });
  } else {
    document.querySelectorAll('.mobile-accordion__item').forEach(function (item) {
      var btn = item.querySelector('.mobile-accordion__toggle');
      if (btn.getAttribute('data-initialized')) {
        btn.removeAttribute('data-initialized');
        btn.setAttribute('aria-expanded', 'false');
        item.classList.remove('active');
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', initAccordion);
window.addEventListener('resize', initAccordion);


// Product Card Cart Module Functionality
class ProductCardCartModule {
  constructor() {
    console.log("🚀 ProductCardCartModule: Constructor started");
    this.initialized = new WeakSet();
    this.init();
    this.setupObservers();
    console.log("✅ ProductCardCartModule: Constructor completed");
  }

  init() {
    console.log("🔧 ProductCardCartModule: Init started");
    this.bindEvents();
    this.initializeExistingCards();
    console.log("✅ ProductCardCartModule: Init completed");
  }

  bindEvents() {
    console.log("🎯 ProductCardCartModule: Binding events");
    // Use event delegation to handle dynamically loaded content
    document.addEventListener("click", this.handleQuantityChange.bind(this));
    document.addEventListener("click", this.handleAddToCartClick.bind(this));
    console.log("✅ ProductCardCartModule: Events bound");
  }

  initializeExistingCards() {
    console.log("🔍 ProductCardCartModule: Looking for existing cards");
    // Initialize all existing product cards on page load
    const existingCards = document.querySelectorAll("product-card");
    console.log(
      `📦 ProductCardCartModule: Found ${existingCards.length} existing cards`
    );

    existingCards.forEach((card, index) => {
      console.log(
        `🎯 ProductCardCartModule: Initializing card ${index + 1}`,
        card
      );
      this.initializeProductCard(card);
    });
    console.log("✅ ProductCardCartModule: Existing cards initialized");
  }

  handleQuantityChange(event) {
    console.log("🖱️ ProductCardCartModule: Click event detected", event.target);
    console.log("🔍 ProductCardCartModule: Event target details:", {
      tagName: event.target.tagName,
      className: event.target.className,
      closest_button: event.target.closest("button"),
      closest_quantity_button: event.target.closest(
        ".quantity-selector__button"
      ),
    });

    // Check if it's a quantity selector button (both button and anchor tags)
    const button = event.target.closest(".quantity-selector__button");
    if (!button) {
      console.log("❌ ProductCardCartModule: Not a quantity button");
      console.log(
        "🔍 ProductCardCartModule: Available buttons near click:",
        event.target.closest("product-card")?.querySelectorAll("button") ||
          "No product card found"
      );
      return;
    }

    console.log("✅ ProductCardCartModule: Found quantity button", button);

    // Only handle buttons in product cards, not in cart or other places
    const productCard = button.closest("product-card");
    if (!productCard) {
      console.log(
        "❌ ProductCardCartModule: Quantity button not in product card"
      );
      return;
    }

    console.log(
      "✅ ProductCardCartModule: Button is in product card",
      productCard
    );

    // Only handle buttons, not anchor tags (cart uses anchor tags)
    if (button.tagName === "A") {
      console.log(
        "❌ ProductCardCartModule: Anchor tag, letting default behavior handle it"
      );
      return;
    }

    // Check if this quantity selector is part of theme's built-in functionality
    const quantitySelector = button.closest("quantity-selector");

    // If it's a custom element (theme's quantity-selector), let theme handle it
    if (quantitySelector && quantitySelector.tagName === "QUANTITY-SELECTOR") {
      console.log(
        "❌ ProductCardCartModule: Theme quantity-selector custom element detected, skipping"
      );
      return;
    }

    // If the quantity selector has theme-specific attributes, let theme handle it
    if (
      quantitySelector &&
      (quantitySelector.hasAttribute("data-quantity-selector") ||
        quantitySelector.classList.contains("quantity-input") ||
        quantitySelector.classList.contains("js-qty"))
    ) {
      console.log(
        "❌ ProductCardCartModule: Theme quantity selector attributes detected, skipping"
      );
      return;
    }

    // Check if the button has theme-specific event listeners already
    if (
      button.hasAttribute("data-quantity-button") ||
      button.classList.contains("js-qty-btn") ||
      button.onclick !== null
    ) {
      console.log(
        "❌ ProductCardCartModule: Theme quantity button detected, skipping"
      );
      return;
    }

    console.log(
      "✅ ProductCardCartModule: Product card quantity button clicked",
      button
    );
    event.preventDefault();
    event.stopPropagation();

    if (!quantitySelector) {
      console.log("❌ ProductCardCartModule: No quantity selector found");
      return;
    }

    console.log(
      "✅ ProductCardCartModule: Quantity selector found",
      quantitySelector
    );

    const input = quantitySelector.querySelector(".quantity-selector__input");
    if (!input) {
      console.log("❌ ProductCardCartModule: No input found");
      return;
    }

    console.log("✅ ProductCardCartModule: Input found", input);

    const currentValue = parseInt(input.value) || 1;
    const min = parseInt(input.min) || 1;
    const max = parseInt(input.max) || 999;
    const step = parseInt(input.step) || 1;

    console.log(
      `📊 ProductCardCartModule: Current values - value: ${currentValue}, min: ${min}, max: ${max}, step: ${step}`
    );

    let newValue = currentValue;

    // Check if it's minus button (path: "M0 6h12") or plus button (path: "M6 0v12M0 6h12")
    const svgPath = button.querySelector("svg path");
    console.log("🔍 ProductCardCartModule: SVG path found:", svgPath);
    console.log(
      "🔍 ProductCardCartModule: SVG path d attribute:",
      svgPath?.getAttribute("d")
    );

    const minusIcon = button.querySelector('svg path[d="M0 6h12"]');
    const plusIcon = button.querySelector('svg path[d="M6 0v12M0 6h12"]');

    console.log("🔍 ProductCardCartModule: Icon detection:", {
      minusIcon,
      plusIcon,
    });

    if (minusIcon && !plusIcon) {
      newValue = Math.max(min, currentValue - step);
      console.log(
        `➖ ProductCardCartModule: Minus clicked, new value: ${newValue}`
      );
    } else if (plusIcon) {
      newValue = Math.min(max, currentValue + step);
      console.log(
        `➕ ProductCardCartModule: Plus clicked, new value: ${newValue}`
      );
    } else {
      console.log("⚠️ ProductCardCartModule: Could not determine button type");
      console.log("🔍 ProductCardCartModule: Button HTML:", button.innerHTML);
      return;
    }

    if (newValue !== currentValue) {
      input.value = newValue;
      this.updateQuantityButtons(quantitySelector, newValue, min, max);

      // Update the hidden quantity input in the form
      const hiddenQuantityInput = productCard.querySelector(
        ".product-card__quantity-input"
      );
      if (hiddenQuantityInput) {
        hiddenQuantityInput.value = newValue;
        console.log(
          `🔄 ProductCardCartModule: Updated hidden form quantity to: ${newValue}`
        );
      }

      // Trigger change event for theme compatibility
      input.dispatchEvent(new Event("change", { bubbles: true }));
      input.dispatchEvent(new Event("input", { bubbles: true }));
      console.log(
        `🔄 ProductCardCartModule: Value updated from ${currentValue} to ${newValue}`
      );
    } else {
      console.log("⚠️ ProductCardCartModule: Value unchanged");
    }
  }

  updateQuantityButtons(quantitySelector, value, min, max) {
    console.log(
      `🔄 ProductCardCartModule: Updating buttons for value: ${value}`
    );
    const buttons = quantitySelector.querySelectorAll(
      ".quantity-selector__button"
    );
    console.log(`🔍 ProductCardCartModule: Found ${buttons.length} buttons`);

    buttons.forEach((button, index) => {
      // Skip anchor tags
      if (button.tagName === "A") {
        console.log(`⏭️ ProductCardCartModule: Skipping anchor tag ${index}`);
        return;
      }

      const minusIcon = button.querySelector('svg path[d="M0 6h12"]');
      const plusIcon = button.querySelector('svg path[d="M6 0v12M0 6h12"]');

      if (minusIcon && !plusIcon) {
        button.disabled = value <= min;
        console.log(
          `➖ ProductCardCartModule: Minus button ${index} disabled: ${button.disabled}`
        );
      } else if (plusIcon) {
        button.disabled = value >= max;
        console.log(
          `➕ ProductCardCartModule: Plus button ${index} disabled: ${button.disabled}`
        );
      }
    });
  }

  handleAddToCartClick(event) {
    console.log(
      "🛒 ProductCardCartModule: Click event for add to cart",
      event.target
    );

    // Check if it's an add to cart button
    const button = event.target.closest(".product-card__add-to-cart-btn");
    if (!button) {
      return;
    }

    console.log("✅ ProductCardCartModule: Add to cart button clicked", button);

    // Only handle buttons in product cards
    const productCard = button.closest("product-card");
    if (!productCard) {
      console.log(
        "❌ ProductCardCartModule: Add to cart button not in product card"
      );
      return;
    }

    console.log(
      "✅ ProductCardCartModule: Button is in product card",
      productCard
    );

    // Find the form
    const form = productCard.querySelector(".product-card__form");
    if (form) {
      console.log(
        "✅ ProductCardCartModule: Found form, submitting via AJAX",
        form
      );
      event.preventDefault();
      event.stopPropagation();

      // Get the current quantity from the quantity selector
      const quantityInput = productCard.querySelector(
        ".quantity-selector__input"
      );
      const currentQuantity = quantityInput
        ? parseInt(quantityInput.value) || 1
        : 1;
      console.log(
        `📊 ProductCardCartModule: Current quantity: ${currentQuantity}`
      );

      // Update the hidden quantity input in the form
      const hiddenQuantityInput = form.querySelector(
        ".product-card__quantity-input"
      );
      if (hiddenQuantityInput) {
        hiddenQuantityInput.value = currentQuantity;
        console.log(
          `🔄 ProductCardCartModule: Updated form quantity to: ${currentQuantity}`
        );
      } else {
        console.log("⚠️ ProductCardCartModule: No hidden quantity input found");
      }

      // Add loading state
      button.disabled = true;
      const addText = button.querySelector(".product-card__add-text");
      const originalText = addText ? addText.textContent : "";
      if (addText) {
        addText.textContent = "Ekleniyor...";
      }

      // Submit via AJAX instead of regular form submission
      this.submitFormViaAjax(form, button, addText, originalText);
    } else {
      console.log(
        "⚠️ ProductCardCartModule: No form found, letting default behavior handle"
      );
      // For multi-variant products, let the modal open
    }
  }

  async submitFormViaAjax(form, button, addText, originalText) {
    console.log("🌐 ProductCardCartModule: Submitting form via AJAX", form);

    try {
      // Prepare bundled sections like the theme does
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:prepare-bundled-sections", {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );

      const formData = new FormData(form);

      // Add sections and sections_url like the theme does
      formData.set("sections", sectionsToBundle.join(","));
      const variantId = formData.get("id");
      formData.set(
        "sections_url",
        `${Shopify.routes.root}variants/${variantId}`
      );

      // Log form data for debugging
      console.log("📝 ProductCardCartModule: Form data:");
      for (let [key, value] of formData.entries()) {
        console.log(`  ${key}: ${value}`);
      }

      const response = await fetch("/cart/add.js", {
        method: "POST",
        body: formData,
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
      });

      if (response.ok) {
        const responseJson = await response.json();
        console.log(
          "✅ ProductCardCartModule: Product added successfully",
          responseJson
        );

        // Fetch updated cart data like the theme does
        const cartContent = await (await fetch("/cart.js")).json();
        console.log("🛒 ProductCardCartModule: Updated cart data", cartContent);

        // Add sections to cart content like the theme does
        cartContent["sections"] = responseJson["sections"];

        // Dispatch variant:add event first (like theme does)
        form.dispatchEvent(
          new CustomEvent("variant:add", {
            bubbles: true,
            detail: {
              items: responseJson.hasOwnProperty("items")
                ? responseJson["items"]
                : [responseJson],
              cart: cartContent,
              onSuccessDo: formData.get("on_success"),
            },
          })
        );

        // Then dispatch cart:change event to trigger theme's cart drawer
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:change", {
            bubbles: true,
            detail: {
              baseEvent: "variant:add",
              onSuccessDo: formData.get("on_success"),
              cart: cartContent,
            },
          })
        );
      } else {
        const responseJson = await response.json();
        console.error(
          "❌ ProductCardCartModule: Error adding to cart",
          responseJson
        );

        // Dispatch cart:error event like the theme does
        form.dispatchEvent(
          new CustomEvent("cart:error", {
            bubbles: true,
            detail: {
              error: responseJson["description"],
            },
          })
        );

        alert(
          responseJson["description"] ||
            "Ürün sepete eklenirken bir hata oluştu."
        );
      }
    } catch (error) {
      console.error("❌ ProductCardCartModule: Network error", error);
      alert("Ağ hatası oluştu. Lütfen tekrar deneyin.");
    } finally {
      // Reset button state
      button.disabled = false;
      if (addText) {
        addText.textContent = originalText;
      }
      console.log("✅ ProductCardCartModule: Button state reset");
    }
  }

  setupObservers() {
    console.log("👀 ProductCardCartModule: Setting up observers");
    // 1. Mutation Observer - for DOM changes (AJAX content, infinite scroll, etc.)
    this.setupMutationObserver();

    // 2. Intersection Observer - for cards entering viewport
    this.setupIntersectionObserver();

    // 3. Listen for common Shopify/theme events
    this.setupShopifyEventListeners();
    console.log("✅ ProductCardCartModule: All observers set up");
  }

  setupMutationObserver() {
    console.log("🔍 ProductCardCartModule: Setting up mutation observer");
    const observer = new MutationObserver((mutations) => {
      console.log(
        `🔄 ProductCardCartModule: ${mutations.length} mutations detected`
      );
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Check if the node itself is a product card
            if (node.tagName === "PRODUCT-CARD") {
              console.log(
                "📦 ProductCardCartModule: New product card detected via mutation",
                node
              );
              this.initializeProductCard(node);
            }

            // Find product cards within the added node
            if (node.querySelectorAll) {
              const productCards = node.querySelectorAll("product-card");
              if (productCards.length > 0) {
                console.log(
                  `📦 ProductCardCartModule: ${productCards.length} product cards found in new content`
                );
                productCards.forEach((card) =>
                  this.initializeProductCard(card)
                );
              }
            }
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
    console.log("✅ ProductCardCartModule: Mutation observer active");
  }

  setupIntersectionObserver() {
    console.log("👁️ ProductCardCartModule: Setting up intersection observer");
    // Initialize cards when they become visible
    const observer = new IntersectionObserver(
      (entries) => {
        console.log(
          `👁️ ProductCardCartModule: ${entries.length} intersection entries`
        );
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.target.tagName === "PRODUCT-CARD") {
            console.log(
              "👁️ ProductCardCartModule: Product card entered viewport",
              entry.target
            );
            this.initializeProductCard(entry.target);
          }
        });
      },
      {
        rootMargin: "50px", // Initialize slightly before they're fully visible
      }
    );

    // Observe existing cards
    const existingCards = document.querySelectorAll("product-card");
    console.log(
      `👁️ ProductCardCartModule: Adding ${existingCards.length} cards to intersection observer`
    );
    existingCards.forEach((card) => {
      observer.observe(card);
    });

    // Store observer to use for new cards
    this.intersectionObserver = observer;
    console.log("✅ ProductCardCartModule: Intersection observer active");
  }

  setupShopifyEventListeners() {
    console.log("🛍️ ProductCardCartModule: Setting up Shopify event listeners");

    // Listen for cart:change event (when cart is updated)
    document.addEventListener("cart:change", (event) => {
      console.log(
        "🛒 ProductCardCartModule: cart:change event detected",
        event.detail
      );

      const cart = event.detail.cart; // The whole cart content after the update
      const baseEvent = event.detail.baseEvent; // The event that triggered this (e.g., 'variant:add')
      const onSuccessDo = event.detail.onSuccessDo; // What to do on success (e.g., 'force_open_drawer')

      console.log("🛒 ProductCardCartModule: Updated cart:", cart);
      console.log("📦 ProductCardCartModule: Base event:", baseEvent);
      console.log("🎯 ProductCardCartModule: On success do:", onSuccessDo);

      // The theme will automatically open the cart drawer if onSuccessDo === 'force_open_drawer'
      // We don't need to manually open it
      if (baseEvent === "variant:add" && onSuccessDo === "force_open_drawer") {
        console.log(
          "✅ ProductCardCartModule: Product added to cart, drawer will open automatically"
        );
      }
    });

    // Listen for variant:add event (when product is added to cart) - backup
    document.addEventListener("variant:add", (event) => {
      console.log(
        "🛒 ProductCardCartModule: variant:add event detected",
        event.detail
      );

      const items = event.detail.items; // Get items added
      const cart = event.detail.cart; // The whole cart content after the update

      console.log("📦 ProductCardCartModule: Items added:", items);
      console.log("🛒 ProductCardCartModule: Updated cart:", cart);
    });

    // Listen for common Shopify theme events
    document.addEventListener("shopify:section:load", (event) => {
      console.log(
        "🛍️ ProductCardCartModule: shopify:section:load event",
        event.target
      );
      this.initializeSectionCards(event.target);
    });

    document.addEventListener("shopify:section:reorder", (event) => {
      console.log(
        "🛍️ ProductCardCartModule: shopify:section:reorder event",
        event.target
      );
      this.initializeSectionCards(event.target);
    });

    // Listen for cart drawer updates (might contain recommended products)
    document.addEventListener("cart:updated", () => {
      console.log("🛒 ProductCardCartModule: cart:updated event");
      setTimeout(() => {
        this.initializeExistingCards();
      }, 100);
    });

    // Listen for quick view modals or product recommendations
    document.addEventListener("modal:opened", () => {
      console.log("🪟 ProductCardCartModule: modal:opened event");
      setTimeout(() => {
        this.initializeExistingCards();
      }, 100);
    });

    // Listen for AJAX content loads (common in themes)
    document.addEventListener("ajax:success", () => {
      console.log("🌐 ProductCardCartModule: ajax:success event");
      setTimeout(() => {
        this.initializeExistingCards();
      }, 100);
    });

    // Listen for custom theme events
    document.addEventListener("theme:product-recommendations:loaded", () => {
      console.log(
        "🎯 ProductCardCartModule: theme:product-recommendations:loaded event"
      );
      this.initializeExistingCards();
    });

    document.addEventListener("theme:recently-viewed:loaded", () => {
      console.log(
        "👁️ ProductCardCartModule: theme:recently-viewed:loaded event"
      );
      this.initializeExistingCards();
    });

    console.log("✅ ProductCardCartModule: Shopify event listeners active");
  }

  initializeSectionCards(section) {
    console.log(
      "📄 ProductCardCartModule: Initializing section cards",
      section
    );
    if (section && section.querySelectorAll) {
      const productCards = section.querySelectorAll("product-card");
      console.log(
        `📦 ProductCardCartModule: Found ${productCards.length} cards in section`
      );
      productCards.forEach((card) => this.initializeProductCard(card));
    }
  }

  initializeProductCard(card) {
    console.log("🎯 ProductCardCartModule: Initializing product card", card);

    // Prevent double initialization
    if (this.initialized.has(card)) {
      console.log(
        "⚠️ ProductCardCartModule: Card already initialized, skipping"
      );
      return;
    }

    // Mark as initialized
    this.initialized.add(card);
    console.log("✅ ProductCardCartModule: Card marked as initialized");

    // Add to intersection observer if it exists
    if (this.intersectionObserver) {
      this.intersectionObserver.observe(card);
      console.log(
        "👁️ ProductCardCartModule: Card added to intersection observer"
      );
    }

    // Initialize quantity selectors in the card - but let theme handle the functionality
    const quantitySelectors = card.querySelectorAll(".quantity-selector");
    console.log(
      `🔢 ProductCardCartModule: Found ${quantitySelectors.length} quantity selectors in card`
    );

    quantitySelectors.forEach((selector, index) => {
      console.log(
        `🔢 ProductCardCartModule: Processing quantity selector ${index + 1}`,
        selector
      );
      const input = selector.querySelector(".quantity-selector__input");
      if (input) {
        const value = parseInt(input.value) || 1;
        const min = parseInt(input.min) || 1;
        const max = parseInt(input.max) || 999;
        console.log(
          `📊 ProductCardCartModule: Selector ${
            index + 1
          } values - value: ${value}, min: ${min}, max: ${max}`
        );
        // Don't call updateQuantityButtons here - let theme handle it
      } else {
        console.log(
          `⚠️ ProductCardCartModule: Selector ${index + 1} input not found`
        );
      }
    });

    // Add a data attribute to mark as initialized
    card.setAttribute("data-cart-module-initialized", "true");
    console.log("✅ ProductCardCartModule: Card initialization complete");
  }
}

// Initialize when DOM is ready
console.log("🌟 ProductCardCartModule: Script loaded, checking DOM state");
console.log(
  "📄 ProductCardCartModule: Document ready state:",
  document.readyState
);

if (document.readyState === "loading") {
  console.log(
    "⏳ ProductCardCartModule: DOM still loading, waiting for DOMContentLoaded"
  );
  document.addEventListener("DOMContentLoaded", () => {
    console.log(
      "🎉 ProductCardCartModule: DOMContentLoaded fired, initializing"
    );
    window.productCardCartModule = new ProductCardCartModule();
  });
} else {
  console.log("🎉 ProductCardCartModule: DOM ready, initializing immediately");
  window.productCardCartModule = new ProductCardCartModule();
}

// Also provide a global function for manual initialization
window.initializeProductCards = function () {
  console.log("🔧 ProductCardCartModule: Manual initialization requested");
  if (window.productCardCartModule) {
    window.productCardCartModule.initializeExistingCards();
  } else {
    console.log("❌ ProductCardCartModule: Module not initialized yet");
  }
};

console.log("✅ ProductCardCartModule: Script setup complete");
